<div id="{{target}}" class="map"></div>
<ol-map-marker *ngIf="markers.length > 0" [markers]="markers" icon="assets/imgs/marker.png"></ol-map-marker>
